module.exports = __webpack_public_path__ + "static/media/BG.2066dbc7.jpg";